import { getMappingData } from '../../helpers/mapping-form-data/get-mapping-form-data';
import { getIdProp } from '../../helpers/mapping-form-data/get-mapping-form-data.helper';
import type { CreateLeadAllProductsInterface } from '~/src/repositories/lead/types/lead.types';
import type { MappedDataLeadAllProductsInterface } from './referral-all-products-layout.types';

export const getLeadAllProductsMappingData = (
    props: MappedDataLeadAllProductsInterface,
): CreateLeadAllProductsInterface => {
    const { requestBody } = getMappingData(props);
    const { houseFiasId, referralCode, agentPartyId } = props;

    return {
        ...requestBody,
        houseFiasId: houseFiasId || undefined,
        ...getIdProp(agentPartyId, referralCode),
    };
};
